<template>
  <div>
    <v-navigation-drawer
      class="nav"
      :mini-variant="navCollapsed"
      v-model="nav"
      hide-overlay
      dark
      fixed
      stateless
    >
      <v-layout column justify-space-between fill-height>
        <v-card flat class="transparent">
          <v-toolbar
            color="black"
            :class="`${servers[server].color}--text`"
            class="server-strip"
            dense
            flat
          >
            <v-layout class="justify-center ml-2 ellipsis">
              <template v-if="navCollapsed">
                {{ server.toUpperCase() }}
              </template>
              <v-flex class="nav-server-expanded" ml-3 v-else>
                {{ servers[server].name.toUpperCase() }} <br />
                <a
                  :href="servers[server].platform"
                  target="_blank"
                  :class="`${servers[server].color}--text`"
                  >{{ servers[server].platform }}</a
                >
              </v-flex>
            </v-layout>
          </v-toolbar>
          <v-flex ml-3 pt-2>
            <v-list class="pa-0">
              <v-list-item>
                <v-btn icon @click="navCollapsed = !navCollapsed">
                  <v-icon aria-hidden="false" role="button">
                    {{ navCollapsed ? "menu" : "chevron_left" }}
                  </v-icon>
                </v-btn>
                <v-list-item-content class="pt-3">
                  <v-list-item-title
                    ><strong>McKinsey Hub</strong></v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-flex>

          <!-- TOP MENU -->
          <v-flex ml-4>
            <v-list class="transparent">
              <v-divider></v-divider>
              <nav-link
                v-for="item in topItems"
                :item="item"
                :key="item.title"
                :page="page"
                :nav-collapsed.sync="navCollapsed"
              />
            </v-list>
          </v-flex>
        </v-card>

        <!-- BOTTOM MENU -->
        <v-card class="transparent">
          <v-flex ml-4>
            <v-list class="transparent">
              <nav-link
                v-for="item in bottomItems"
                :item="item"
                :key="item.title"
                :page="page"
                :nav-collapsed.sync="navCollapsed"
              />
            </v-list>
          </v-flex>
        </v-card>
      </v-layout>
    </v-navigation-drawer>
    <div
      class="nav-overlay v-overlay v-overlay--absolute"
      @click="navCollapsed = true"
      :class="{ 'v-overlay--active': !navCollapsed }"
    ></div>
  </div>
</template>

<script>
import { servers } from '../../helpers'
import NavLink from './NavLink.vue'

export default {
  name: 'Nav',
  components: { NavLink },
  props: {
    page: String
  },
  data () {
    return {
      nav: true,
      navCollapsed: true,
      topItems: [
        { title: 'Home', pages: ['home'], icon: 'home', link: '/home' },
        {
          title: 'Accounts',
          pages: [],
          icon: 'group',
          submenu: [
            {
              title: 'Search',
              link: '/accounts/search',
              pages: ['searchAccounts'],
              can: this.$can({ assessment: 'read' })
            },
            {
              title: 'Recently Created',
              link: '/accounts/create',
              pages: ['createAccounts'],
              can: this.$can({ assessment: 'write' })
            }
          ],
          can: this.$anyCan({ assessment: ['read', 'write'] })
        },
        {
          title: 'Assets',
          pages: [],
          icon: 'perm_media',
          submenu: [
            {
              title: 'Import',
              pages: ['assetImport'],
              icon: 'vertical_align_top',
              link: '/assets/import',
              can: this.$can({ assets: 'write' })
            },
            {
              title: 'Create & Edit Assets',
              pages: ['assetUpdate'],
              icon: 'vertical_align_top',
              link: '/assets/update',
              can: this.$can({ assets: 'write' })
            }
          ]
        },
        {
          title: 'Reports',
          pages: [],
          icon: 'timeline',
          submenu: [
            {
              title: 'IA Scores',
              link: '/ia/scores',
              pages: ['scores'],
              can: this.$can({ score: 'read' })
            },
            {
              title: 'Monitor',
              link: '/activities/monitor',
              pages: ['monitor'],
              can: this.$can({ score: 'read' })
            },
            {
              title: 'A2E Scores',
              link: '/a2e/scores',
              pages: ['a2eScores'],
              can: this.$can({ 'a2e-score': 'read' })
            }
          ],
          can: this.$can({ score: 'read' })
        },
        {
          title: 'Schedule',
          pages: ['Schedule'],
          icon: 'date_range',
          link: '/slots',
          can: this.$can({ schedule: 'write' })
        },
        {
          title: 'Scoring',
          pages: [],
          icon: 'score',
          submenu: [
            {
              title: 'Assessment Rescore',
              link: '/ia/scores/rescore',
              pages: ['assessmentRescore'],
              can: this.$can({ score: 'write' })
            },
            {
              title: 'Quartiles',
              link: '/ia/scores/quartiles',
              pages: ['scoresQuartiles'],
              can: this.$can({ quartiles: 'write' })
            },
            {
              title: 'IA Scores',
              link: '/ia/scores',
              pages: ['scores'],
              can: this.$can({ score: 'write' })
            },
            {
              title: 'IA Scoring Model',
              link: '/ia/scores/model',
              pages: ['scoringModel'],
              can: this.$can({ score: 'write' })
            },
            {
              title: 'A2E Scores',
              link: '/a2e/scores',
              pages: ['a2eScores'],
              can: this.$can({ 'a2e-score': 'read' })
            }
          ]
        },
        {
          title: 'BCM',
          icon: 'data_exploration',
          link: '/bcm',
          pages: ['bcmExplore'],
          can: this.$can({ score: 'write' }) && this.isMckidFlow()
        },
        {
          title: 'Dashboard ',
          pages: ['dashboard'],
          icon: 'power',
          link: '/dashboard',
          can: this.$can({ 'survey-group': 'read' })
        },
        {
          title: 'Survey',
          icon: 'data_exploration',
          pages: [],
          submenu: [
            {
              title: 'Survey Responses',
              link: '/survey/responses',
              pages: ['surveyResponse'],
              can: this.$can({ 'survey-response': 'read' })
            },
            {
              title: 'Survey Groups',
              link: '/survey/groups',
              pages: ['surveyGroups'],
              can: this.$can({ 'survey-group': 'read' })
            }
          ]
        }
      ],
      bottomItems: [
        {
          title: 'Settings',
          pages: [],
          icon: 'settings',
          submenu: [
            {
              title: 'My Account',
              pages: ['profile'],
              icon: 'account_box',
              link: '/profile'
            },
            {
              title: 'Task Config',
              link: '/settings/task-types',
              pages: ['tasks'],
              can: this.$can({ task_type: 'write' })
            },
            {
              title: 'Assessment Config',
              link: '/settings/assessment-configs',
              pages: ['assessment-configs'],
              can: this.$anyCan({ task: 'write,promote' })
            },
            {
              title: 'Admin Users',
              link: '/entitlements/admins',
              pages: ['entitlementsAdmins'],
              can: this.$can({ admin: 'write' })
            },
            {
              title: 'Admin Roles',
              link: '/entitlements/roles',
              pages: ['entitlementsRoles'],
              can: this.$can({ admin_role: 'write' })
            },
            {
              title: 'Quartiles',
              link: '/ia/scores/quartiles',
              pages: ['scoresQuartiles'],
              can: this.$can({ quartiles: 'write' })
            },
            {
              title: 'Service Versions',
              link: '/services/service_versions',
              pages: ['serviceVersions'],
              can: this.$can({ service_versions: 'write' })
            }
          ]
        },
        {
          title: 'Log Out',
          pages: [],
          icon: 'power_settings_new',
          action: this.logout
        }
      ],
      servers,
      server: this.$store.state.auth.server
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push('/login')
      })
    },
    isMckidFlow () {
      const mckidToken = this.$store.getters['auth/mckidToken']

      if (mckidToken) {
        return true
      }

      return false
    }
  }
}
</script>

<style lang="sass">
.nav
  min-width: 80px
  margin-left: -10px
  background-color: rgb(30, 36, 41) !important

.nav-server-expanded
  font-size: 13px

.server-strip .v-toolbar__content
  padding: 0

.nav-overlay
  z-index: 2
</style>
